import StudentMessages from '@/domains/agenda/highlight/messages/main';
import StudentPresenceTheme from '@/domains/agenda/highlight/presence-themes/main';

export default {
	name: 'highlight',
	components: {
		StudentMessages,
		StudentPresenceTheme
	}
};



// WEBPACK FOOTER //
// ./sources/domains/agenda/highlight/index.js